import { DispatchEvents, ErrorState, JotType, SubmitState, WidgetState } from "consts";
import {
  clearLocalBackupAlias,
  dispatchEvent,
  getLocalBackupAlias,
  handleError,
  isNullOrUndef,
  jsonToUri,
  widgetCompliance,
} from "utils";

import { envConfig } from "config";
import fetchJsonp from "fetch-jsonp";
import { jot } from "actions/jot";

// TODO(CS-5386): positional signature is getting unwieldy with 5 params; consider refactoring
// to an options object so future additions don't need to juggle param order.
export const getComplianceUrl = (
  state,
  complianceVersion = 0,
  complianceOk = false,
  backupAlias,
  deleteData = false,
) => {
  const { protocol, widgetComplianceEndpoint } = envConfig;
  const { hostname, questionsData, bootstrap } = state;
  const { id: targetId } = bootstrap;
  const complianceApiUrl = `${protocol}${hostname}${widgetComplianceEndpoint}`;
  const complianceParams = {
    target: targetId,
    ...(complianceOk !== null && { accepted: complianceOk ? 1 : 0 }),
    alias: questionsData ? questionsData.alias : null,
    session: questionsData ? questionsData.session : null,
    backupAlias: isNullOrUndef(backupAlias) ? "" : backupAlias,
    version: complianceVersion,
    ...(deleteData && { delete: 1 }),
  };
  const complianceParamsString = jsonToUri(complianceParams);

  return `${complianceApiUrl}?${complianceParamsString}`;
};

export const setComplianceState = ({
  state,
  complianceState,
  complianceVersion,
  saveComplianceAnswer = false,
  deleteData = false,
}) => {
  const { apiTimeoutMS } = envConfig;
  const { config, instanceId, hostname, backupAlias } = state;
  const { compliance } = config;
  const isNoChange = complianceState === null;
  const complianceOk = isNoChange ? null : widgetCompliance.complianceStateOk(complianceState);

  //NOTE: when a Respondent accepts/declines we update config.compliance; no-change leaves state untouched
  const toState = {};
  if (!isNoChange) {
    const updatedCompliance = Object.assign({}, compliance, { accepted: complianceOk });
    toState.complianceState = complianceState;
    toState.config = Object.assign({}, config, { compliance: updatedCompliance });
  }

  const acceptCompliance = () => {
    widgetCompliance.setComplianceStorage(complianceVersion, true);
  };

  const declineCompliance = () => {
    //on decline, clear our local backup alias, and then create a new one
    clearLocalBackupAlias();
    const newBackupAlias = getLocalBackupAlias();
    widgetCompliance.setComplianceStorage(complianceVersion, false);

    //NOTE: when a Respondent declines we revert / initialize a lot of state
    toState.submitState = SubmitState.NotReady;
    //set to BootstrapLoaded so we reload the target, which will recreate the cookie
    toState.widgetState = WidgetState.BootstrapLoaded;
    toState.questionsData = {};
    toState.finishData = {};
    toState.finishParams = [];
    toState.excludeParams = [];
    toState.submitIds = [];
    toState.servedIds = [];
    toState.backupAlias = newBackupAlias;
    toState.questionIndex = 0;
    toState.resetQuestions = true;
  };

  if (!isNoChange) {
    complianceOk ? acceptCompliance() : declineCompliance();
  }

  // Skip on delete-only: JotType.Compliance carries a boolean `accepted`, and delete-only
  // doesn't change compliance state. Form already fires JotType.MenuOoD (or MenuOoYD when
  // combined with opt-out) for delete telemetry.
  if (!isNoChange) {
    jot({
      state,
      space: "poll",
      type: JotType.Compliance,
      data: {
        accepted: complianceOk,
      },
    });
  }

  return saveComplianceAnswer
    ? fetchJsonp(getComplianceUrl(state, complianceVersion, complianceOk, backupAlias, deleteData), {
        timeout: apiTimeoutMS,
      })
        .then((res) => res.json())
        .then(() => {
          if (complianceOk) {
            dispatchEvent(instanceId, this, DispatchEvents.IDSync, false, {
              hostname,
            });
          }
          return toState;
        })
        .catch((e) => {
          if (!isNoChange) declineCompliance();
          return handleError(ErrorState.Compliance, e);
        })
    : toState;
};
